const e = (e2, o, p) => ({ key: e2, type: "complex", ...p ? { op: p } : {}, value: o });
export {
  e as makeFilterItemComplex
};
//# sourceMappingURL=makeFilterItemComplex.js.map
